import * as React from 'react';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import { hideScrollbarStyles } from '../../utils/styles';

interface ICustomModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  xs?: number;
  md?: number;
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '10px',
  maxHeight: '96%',
  overflowY: 'auto',
  ...hideScrollbarStyles,
};

const AddNewCoachModal = ({ isOpen, onClose, children, xs = 8, md = 6.5 }: ICustomModalProps) => (
  <Modal
    open={isOpen}
    onClose={onClose}
    closeAfterTransition
    data-testid="modal-content"
    sx={{
      '& .MuiBackdrop-root': {
        backgroundColor: 'primary.main',
        opacity: '0.5 !important',
      },
    }}
  >
    <Grid container item sx={modalStyle} xs={xs} md={md}>
      {children}
    </Grid>
  </Modal>
);

export default AddNewCoachModal;
